import { ErrorMessage, Form, Formik } from "formik";
import clsx from "clsx";
import * as Yup from "yup";
import React from "react";
import { useSelector } from "react-redux";
import {
  selectProfileInfo,
  selectProfileUrl,
  selectProfileLoading,
} from "../../../store/selectors/Profile";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useDispatch } from "react-redux";
import { changeTeacherEmail } from "../../../store/entities/Auth/Auth.actions";
import { getSelfProfileInfo } from "../../../store/entities/Profile/Profile.actions";
import TextBox from "../../Common/Textbox/small";
import Button from "../../Common/Buttons/small";
import Toast from "../../Common/Toast";
import ToastMessage from "../../Common/ToastMessage";

const UserInfoForm = ({}) => {
  //Setup
  const dispatch = useDispatch();
  const profileData = useSelector(selectProfileInfo);
  const publicUrlName = useSelector(selectProfileUrl);
  const loading = useSelector(selectProfileLoading);
  const userInfoSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email format").required("Required"),
  });

  //Callbacks
  const callback = () => {
    Toast(ToastMessage(14), "success");
  }
  //Handlers
  const handleSelect = () => {
    var el = document.getElementById("profileUrlSelect");
    el.focus();
    el.select();
  };

  const handleSubmit = async (values, actions) => {
    await dispatch(changeTeacherEmail({ email: values.email, callback }))
      .then(async (res) => {
        return await dispatch(getSelfProfileInfo());
      })
      .then((res) => {
        actions.resetForm({
          values: { username: publicUrlName, email: values.email },
        });
      })
      .catch((err) => {
        console.log("ERROR: ", err);
        Toast(ToastMessage(13));
      });
  };

  //Render
  return (
    <>
      {profileData ? (
        <Formik
          validationSchema={userInfoSchema}
          initialValues={{ username: publicUrlName, email: profileData.email }}
          onSubmit={ handleSubmit }
        >
          {(props) => {
            const { handleChange, errors, values } = props;
            return (
              <Form className={clsx("flexColumn", "userInfoForm")}>
                <div className={"flexColumn"}>
                  <label className={clsx("flexColumn", "inputContainer")}>
                    <TextBox
                      loading={true}
                      placeholder={""}
                      error={false}
                      type={"text"}
                      value={values.username}
                      tName={"username"}
                      label={"Username"}
                      additionClass={"EMPHASIS_LARGE smallInput"}
                      htmlFor="outlined-basic-username"
                    />
                    <div className="flex mt-4">
                      <label
                        className={"BODY_EXTRA_SMALL  user-info SECONDARY50"}
                      ></label>
                      <input
                        id="profileUrlSelect"
                        disabled
                        onClick={(e) => handleSelect()}
                        value={`https://teachon.org/${publicUrlName}`}
                        className="w55 BODY_EXTRA_SMALL user-info BOLD_STYLE SECONDARY50"
                      ></input>
                    </div>
                    <ErrorMessage
                      className="error"
                      name="username"
                      component="div"
                    />
                  </label>
                  <label className={clsx("flexColumn", "inputContainer")}>
                    <TextBox
                      id={"email"}
                      value={values.email}
                      error={false}
                      type={"text"}
                      handleChange={handleChange}
                      tName={"email"}
                      name={"email"}
                      label={"Email"}
                      additionClass={"EMPHASIS_LARGE smallInput"}
                      htmlFor="outlined-basic-email"
                    />
                    <ErrorMessage
                      className="error"
                      name="email"
                      component="div"
                    />
                  </label>
                </div>

                <div className={"CENTER_FLEX"}>
                  <div className={"END_FLEX"}>
                    <Button
                      loading={loading}
                      additionClass={""}
                      text={" Save Changes"}
                    />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default UserInfoForm;
